import type { Entity, Persisted } from '@tunasong/schemas'
import { useSyncExternalStore } from 'react'

/**
 * Which items the Move picker is open for (#2543). The picker lives in one host beside the app's alerts, not in the
 * menu that opens it: the menu closes, and the moved row may leave its list, while the Undo toast must stay.
 */
export interface MovePickerRequest {
  items: Persisted<Entity>[]
}

let current: MovePickerRequest | null = null
const listeners = new Set<() => void>()

const emit = () => listeners.forEach(listener => listener())

export const openMovePicker = (items: Persisted<Entity>[]) => {
  current = { items }
  emit()
}

export const closeMovePicker = () => {
  current = null
  emit()
}

const subscribe = (listener: () => void) => {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

export const useMovePickerRequest = () => useSyncExternalStore(subscribe, () => current)
